var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useMemo } from 'react';
import { Divider, Menu, Switch } from '@material-ui/core';
import { mdiDotsVertical, mdiTrashCan, mdiClose, mdiLaunch, mdiDownload } from '@mdi/js';
import { Icon } from '@mdi/react';
import { useModal } from '../../../../hooks/useModal';
import { formatBytes } from '../../../../utils/bytes';
import { TooltippedButtonSize } from '../../../Buttons/styles/TooltippedButton';
import Modal from '../../../Modals';
import { DotMenuButton, UninstallDialog, UninstallDescription, RemoveCacheDialog, RemoveCacheSubDialog, StyledMenuItem } from './lab.styles';
export const LabContextMenu = ({ handleLaunch, handleCacheClear, handleDelete, requiredStorage, cacheSize, isLabInstalled, handleInstall, isInstalling }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { modalOpen: uninstallOpen, handleModalOpen, handleModalClose } = useModal();
    const [clearCacheOnDelete, setclearCacheOnDelete] = useState(false);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const formattedBytes = useMemo(() => formatBytes(clearCacheOnDelete ? requiredStorage + cacheSize : requiredStorage, 2), [clearCacheOnDelete, requiredStorage, cacheSize]);
    const launch = () => {
        handleLaunch();
        handleClose();
    };
    const install = () => {
        if (isInstalling)
            return;
        handleInstall();
        handleClose();
    };
    const cacheClear = () => {
        if (isInstalling)
            return;
        handleCacheClear();
        handleClose();
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const onDeleteConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        handleModalClose();
        if (clearCacheOnDelete)
            yield handleCacheClear();
        yield handleDelete();
        return;
    });
    const onDelete = () => {
        handleModalOpen();
        handleClose();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DotMenuButton, { "aria-label": 'more actions menu', size: TooltippedButtonSize.Medium, onClick: handleClick, icon: React.createElement(Icon, { path: mdiDotsVertical }), title: 'More actions' }),
        React.createElement(Menu, { id: "lab-edit-menu", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose, getContentAnchorEl: null, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right'
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right'
            } },
            isLabInstalled ? (React.createElement(StyledMenuItem, { onClick: launch },
                React.createElement(Icon, { path: mdiLaunch }),
                "Launch all machines")) : (React.createElement(StyledMenuItem, { onClick: install, disabled: isInstalling },
                React.createElement(Icon, { path: mdiDownload }),
                "Install Lab")),
            React.createElement(StyledMenuItem, { onClick: cacheClear, disabled: cacheSize <= 1 || isInstalling },
                React.createElement(Icon, { path: mdiClose }),
                "Clear cached files"),
            isLabInstalled ? (React.createElement(React.Fragment, null,
                React.createElement(Divider, null),
                React.createElement(StyledMenuItem, { onClick: onDelete },
                    React.createElement(Icon, { path: mdiTrashCan }),
                    "Uninstall lab"))) : null),
        React.createElement(Modal, { open: uninstallOpen, onClose: handleModalClose, onConfirm: onDeleteConfirm, modalTitle: 'Uninstall virtual lab', showCloseIcon: true },
            React.createElement(UninstallDialog, null,
                React.createElement(UninstallDescription, null,
                    "This will free up ",
                    formattedBytes,
                    " of hard drive space on your computer. Are you sure you want to uninstall this lab?"),
                React.createElement(RemoveCacheDialog, null,
                    React.createElement(Switch, { color: 'primary', disabled: cacheSize <= 1, checked: clearCacheOnDelete, onClick: () => setclearCacheOnDelete(!clearCacheOnDelete) }),
                    React.createElement(UninstallDialog, null,
                        React.createElement(UninstallDescription, null, "Remove settings and virtual machine cache files"),
                        React.createElement(RemoveCacheSubDialog, null, "Might increase download times of future installations")))))));
};
//# sourceMappingURL=LabContextMenu.js.map